import { asNumber, asString, FALLBACK_IMAGE_HERO, resolveUserAvatar, upscaleArtwork } from "./common";
import { createTrackModel } from "./trackModel";
import { createUserModel } from "./userModel";

export function createPlaylistModel(playlist = {}) {
  const artwork = asString(playlist.artwork_url);
  const rawTracks = Array.isArray(playlist.tracks) ? playlist.tracks : [];
  return {
    id: asNumber(playlist.id),
    title: asString(playlist.title, "Untitled Playlist"),
    description: asString(playlist.description),
    track_count: asNumber(playlist.track_count),
    last_modified: asString(playlist.last_modified),
    uri: asString(playlist.uri),
    permalink_url: asString(playlist.permalink_url),
    artwork_url: artwork,
    hdArtworkURL: upscaleArtwork(artwork, "t500x500"),
    user: createUserModel(playlist.user),
    tracks: rawTracks.map(createTrackModel),
  };
}

export function createPlaylistCardModel(playlist) {
  const normalized = createPlaylistModel(playlist);
  return {
    id: `playlist-${normalized.id || normalized.title || "unknown"}`,
    title: normalized.title,
    artist: normalized.user?.username || "Unknown Creator",
    duration: `${normalized.track_count} tracks`,
    image: normalized.hdArtworkURL || resolveUserAvatar(normalized.user),
    model: normalized,
  };
}

export function createAlbumCardModel(album) {
  const normalized = createPlaylistModel(album);
  return {
    id: `album-${normalized.id || normalized.title || "unknown"}`,
    title: normalized.title,
    artist: normalized.user?.username || "Unknown Artist",
    duration: `${normalized.track_count} tracks`,
    image: normalized.hdArtworkURL || resolveUserAvatar(normalized.user),
    model: normalized,
  };
}

export function createPlaylistHeroModel(playlist) {
  const normalized = createPlaylistModel(playlist);
  const image = normalized.hdArtworkURL || FALLBACK_IMAGE_HERO;

  return {
    title: normalized.title || "Trending Playlist",
    subtitle:
      normalized.description ||
      "Fresh handpicked tracks curated from SoundCloud charts and community trends.",
    listeners: normalized.user?.username
      ? `Curated by ${normalized.user.username}`
      : "Live from SoundCloud",
    duration: `${Math.max(0, normalized.track_count)} tracks`,
    image,
    model: normalized,
  };
}
